<script>
  import { Modal,Button } from "../../components/index.svelte";
  import { translator } from "../../store";
  export let propertyToDelete;
  export let onDeleteClick;

  let toggler;

  export function openModal() {
    toggler();
  }
</script>
<Modal
  bind:toggle={toggler}
  title={translator("Dikkat!")}
  onClose={() => {
    propertyToDelete = null;
  }}
>
  <div slot="modal-body">
    {translator(
      '"__PROPERTYNAME__" Ev bilgilerini kalıcı olarak silmek istediğinize emin misiniz?',
      {
        __PROPERTYNAME__: `${propertyToDelete.name}`,
      }
    )}
  </div>
  <div slot="modal-footer">
    <Button
      size="sm"
      onClick={() => onDeleteClick(propertyToDelete.id)}
    >
      {translator("Sil")}
    </Button>
    <Button size="sm" onClick={toggler} colorCls="btn-dark">
      {translator("Vazgeç")}
    </Button>
  </div>
</Modal>
